import useUserStore from '@/composables/useUserStore';
import { computed } from 'vue';
export default {
  __name: 'UserInfo',
  setup(__props) {
    const {
      isAuthenticated,
      userName,
      companyName,
      companyId
    } = useUserStore();
    const isDemo = computed(() => {
      return companyId.value === process.env.VUE_APP_DEFAULT_COMPANY_ID;
    });
    return {
      __sfc: true,
      isAuthenticated,
      userName,
      companyName,
      companyId,
      isDemo
    };
  }
};